import { getIconName } from './getIconName';
import { getIconSettings } from './getIconSettings';

export const getIcon = (d: any) => getIconSettings(getIconName(d), d);